import { TextScrollConfig } from "../textbox";

export const TEXTBOX_CONFIG: TextScrollConfig = {
    charDelayMs: 20,
    sfxDelayMs: 100,
    sfx: "text-calm1",
};
